export const iconFontAwesomeHumanitarianPersonWalkingArrowLoopLeft = (
	<i className="fa-solid fa-person-walking-arrow-loop-left"></i>
);
